export class Statuses {
    static options() {
        return [
            {
                value: 'DRAFT',
                text: 'Draft'
            },
            {
                value: 'SUBMITTED',
                text: 'Submitted'
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/helpers/statuses-options.js